module.exports = __webpack_public_path__ + "assets/images/template/project/photo-3-desktop.jpg?v=208c5443";